import { useEffect } from 'react';

const cityFontClassMap = {
  mysuru: 'kn',
  bengaluru: 'kn',
  jhansi: 'dv',
  kolkata: 'bn',
  chennai: 'tm',
  hyderabad: 'tl',
  ahmedabad: 'gu',
  chandigarh: 'pa',
  bhubaneswar: 'or',
  kochi: 'ml',
  mumbai: 'dv',
  delhi: 'dv'
};

const fontSubsetMap = {
  gu: 'Gujarati',
  kn: 'Kannada',
  ml: 'Malayalam',
  dv: 'Devanagari',
  bn: 'Bengali',
  tm: 'Tamil',
  tl: 'Telugu',
  pa: 'Gurmukhi',
  or: 'Oriya',
  // fallback handled in logic
};

export function useFontLoader() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const city = params.get('q')?.toLowerCase();
    const className = cityFontClassMap[city];

    if (className) {
      document.body.classList.add(className);

      const subset = fontSubsetMap[className] || 'Latin';
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = `https://fonts.googleapis.com/css2?family=Noto+Sans+${subset}&display=swap`;
      document.head.appendChild(link);
    }
  }, []);
}
